import { Col, Form, Row } from 'antd';
import { Store } from 'antd/lib/form/interface';
import Modal from 'antd/lib/modal/Modal';
import React, { useContext, useEffect, useState } from 'react';

import AnchorComponent from 'components/atoms/AnchorComponent';
import ButtonComponent from 'components/atoms/ButtonComponent';
import InputComponent from 'components/atoms/InputComponent';
import Paragraph from 'components/atoms/Paragraph';
import SelectComponent from 'components/atoms/SelectComponent';
import LoadingWrapper from 'components/hoc/LoadingWrapper';
import { Context } from 'components/hoc/Store';
import TranslateText from 'components/hoc/TranslateText';
import FormWrapper from 'components/molecules/FormWrapper';

import checkLeiApi from 'services/akcionar/emise/checkLei';
import identifikaceEmitenta, { IIdentifikaceEmitenta } from 'services/akcionar/emise/identifikaceEmitenta';
import isinRozcestnikApi, { IRozcestnikData } from 'services/akcionar/emise/rozcestnikISIN';
import { isinZadostPost } from 'services/akcionar/emise/zadostISIN';
import { IcisStaty } from 'services/cisStaty';

import { ERozcestnikResponse } from 'enums/amlz/rozcestnikResponse';
import { EEmitentJe } from 'enums/isin/emitentJe';
import { EEmitentZadaOpridISIN } from 'enums/isin/emitentZadaOpridISIN';
import { EEvidenceCp } from 'enums/isin/evidenceCp';
import { ERozcestnikOptions } from 'enums/isin/rozcestnikOptions';
import { EDruhCp } from 'enums/isin/udaje/druhCp';
import routePathEnum from 'enums/routePathEnum';

import emitentZadaOpridISN from 'data/codebooks/emise/emitentZadaOpridISINselect';
import evidenceCpSelect, { evidenceCpSelectZAKN } from 'data/codebooks/emise/evidenceCpSelect';

import isinValidation from 'utils/validations/isinValidation';
import leiValidation from 'utils/validations/leiValidation';

import { IRozcestnikInput } from './IdentifikaceEmitentaNovy';

interface IRozcestnik {
    cisStaty: IcisStaty[];
    nextStep: () => void;
    rozcestnikData?: IRozcestnikData['spolecnost'];
    setRozcestnikData: React.Dispatch<React.SetStateAction<IRozcestnikData['spolecnost'] | undefined>>;
    setRozcestnikInput: React.Dispatch<React.SetStateAction<IRozcestnikInput | undefined>>;
    rozcestnikInput?: IRozcestnikInput;
    setZadostID: (value: number) => void;
    identifikacePutData?: IIdentifikaceEmitenta;
    zadostID?: number;
    setDruhCP: React.Dispatch<React.SetStateAction<EDruhCp | undefined>>;
    setIdentifikacePutData: React.Dispatch<React.SetStateAction<IIdentifikaceEmitenta | undefined>>;
    isRegistration?: boolean;
}

const Rozcestnik: React.FC<IRozcestnik> = ({
    cisStaty,
    nextStep,
    rozcestnikData,
    setRozcestnikData,
    setRozcestnikInput,
    setZadostID,
    rozcestnikInput,
    identifikacePutData,
    zadostID,
    setDruhCP,
    setIdentifikacePutData,
    isRegistration
}) => {
    const [form] = Form.useForm();
    const { aktivniFirma, isin, menuProfile } = useContext(Context);
    const [loading, setLoading] = useState<boolean>(false);
    const [showOsobaSelect, setShowOsobaSelect] = useState<boolean>(false);
    const [leiCheck, setLeiCheck] = useState<boolean>(false);
    const [openModal, setOpenModal] = useState<boolean>(false);
    // const [rozcestnikErr, setRozcestnikErr] = useState<string>('');
    const [modalMessage, setModalMessage] = useState<string>('');
    const [errMessage, setErrMesage] = useState<string>('');

    const onFinish = (value: Store) => {
        setLoading(val => !val);
        if (!leiCheck) {
            if (identifikacePutData && value.evidencecp) {
                setIdentifikacePutData(pv => {
                    const newState = {
                        ...pv,
                        evidencecp: value.evidencecp
                    };
                    delete newState.druhcp;
                    return newState;
                });
                setDruhCP(undefined);
            }

            setRozcestnikInput({
                emitentje: menuProfile?.typemitenta || value.emitentje,
                ...(value.evidencecp && {
                    evidencecp: value.evidencecp
                }),
                podobacp: value.podobacp
            });
            isinRozcestnikApi({
                // sluzba rozhodne ci user prejde na dalsiu stranku alebo LEIcheck
                zadao: isRegistration ? ERozcestnikOptions.REGISTRATION : ERozcestnikOptions.NOVY,
                emitentje:
                    menuProfile?.typemitenta ||
                    identifikacePutData?.emitentje ||
                    rozcestnikInput?.emitentje ||
                    EEmitentJe.NA,
                ...(value.evidencecp && {
                    evidencecp: value.evidencecp
                }),
                podobacp: value.podobacp,
                idmb: value.idmb,
                stat: value.stat
            })
                .then(resp => {
                    setRozcestnikData({
                        ...((rozcestnikData?.lei || value.lei) && {
                            lei: rozcestnikData?.lei || value.lei
                        }),
                        ...(value.cval && {
                            cval: value.cval
                        }),
                        ...resp.spolecnost
                    });
                    if (resp.nasledujeweb === 'CHYBA') {
                        setErrMesage(resp.nasledujeweb);
                    } else if (resp.nasledujeweb === ERozcestnikResponse.ISINLEI) {
                        setLeiCheck(true);
                    } else if (
                        resp.nasledujeweb === ERozcestnikResponse.CEKA ||
                        resp.nasledujeweb === ERozcestnikResponse.CEKALEI
                    ) {
                        setOpenModal(true);
                        setModalMessage('FORMULARE_CEKANI_NA_ZPRACOVANI_AMLZ');
                    } else if (
                        resp.nasledujeweb === ERozcestnikResponse.AMLZ ||
                        resp.nasledujeweb === ERozcestnikResponse.AMLZLEI
                    ) {
                        setOpenModal(true);
                        setModalMessage('ZADOST_O_ISIN_AMLZ');
                    } else if (!isin) {
                        return zadostID
                            ? identifikaceEmitenta(
                                  'PUT',
                                  zadostID,
                                  {
                                      ...resp.spolecnost,
                                      pscm: String(resp.spolecnost.pscm) || '',
                                      idmb: value.idmb,
                                      emitentje: menuProfile?.typemitenta || value.emitentje,
                                      ...(value.evidencecp && {
                                          evidencecp: value.evidencecp
                                      }),
                                      ...(value.cval && {
                                          cval: value.cval
                                      }),
                                      podobacp: value.podobacp,
                                      stat: value.stat
                                  },
                                  isRegistration ? 'Registration' : undefined
                              ).then(() => nextStep())
                            : isinZadostPost(value.idmb, value.stat, isRegistration).then(data => {
                                  identifikaceEmitenta(
                                      'PUT',
                                      data.idzadosti,
                                      {
                                          ...resp.spolecnost,
                                          pscm: String(resp.spolecnost.pscm) || '',
                                          idmb: value.idmb,
                                          emitentje: menuProfile?.typemitenta || value.emitentje,
                                          ...(value.evidencecp && {
                                              evidencecp: value.evidencecp
                                          }),
                                          ...(value.cval && {
                                              cval: value.cval
                                          }),
                                          podobacp: value.podobacp,
                                          stat: value.stat
                                      },
                                      isRegistration ? 'Registration' : undefined
                                  );
                                  setZadostID(data.idzadosti);
                                  nextStep(); // "ISIN" -> pokračuji dál
                              });
                    } else if (isin) {
                        nextStep();
                    }
                })
                // .catch(() => setRozcestnikErr('NEVALIDNI_NENI_FO'))
                .finally(() => setLoading(val => !val));
        } else {
            checkLeiApi(value.lei)
                .then(data => {
                    if (
                        (value.stat === 'CZ' && data.ic !== value.idmb) ||
                        (value.stat !== 'CZ' && value.stat !== data.stat)
                    ) {
                        setOpenModal(true);
                        setModalMessage('FORMULARE_LEI_VEDENO_PRO_JINOU_SPOL');
                    } else if (data.stav !== 'ISSUED' && data.stav !== 'PENDING_TRANSFER') {
                        setOpenModal(true);
                        setModalMessage(data.stav === 'LAPSED' ? 'FORMULARE_LEI_LAPSED_FO' : 'FORMULARE_LEI_ZRUSENE');
                    } else {
                        setRozcestnikData({
                            idmb: data.ic,
                            stat: data.stat,
                            nazev: data.spolecnost,
                            ...rozcestnikData,
                            ...(value.cval && {
                                cval: value.cval
                            }),
                            ...(data.forma && {
                                forma: data.forma
                            }),
                            lei: data.lei || value.lei || rozcestnikData?.lei
                        });
                        return zadostID
                            ? identifikaceEmitenta(
                                  'PUT',
                                  zadostID,
                                  {
                                      ...rozcestnikData,
                                      ...rozcestnikInput,
                                      idmb: String(rozcestnikData?.idmb) || '',
                                      pscm: String(rozcestnikData?.pscm) || '',
                                      lei: String(value.lei) || '',
                                      ...(value.cval && {
                                          cval: value.cval
                                      })
                                  },
                                  isRegistration ? 'Registration' : undefined
                              ).then(() => nextStep())
                            : isinZadostPost(value.idmb, value.stat, isRegistration).then(resp => {
                                  identifikaceEmitenta(
                                      'PUT',
                                      resp.idzadosti,
                                      {
                                          ...rozcestnikData,
                                          ...rozcestnikInput,
                                          idmb: String(rozcestnikData?.idmb) || '',
                                          pscm: String(rozcestnikData?.pscm) || '',
                                          lei: String(value.lei) || '',
                                          ...(value.cval && {
                                              cval: value.cval
                                          })
                                      },
                                      isRegistration ? 'Registration' : undefined
                                  );
                                  setZadostID(resp.idzadosti);
                                  nextStep(); // "ISIN" -> pokračuji dál
                              });
                    }
                })
                .catch(() => {
                    setOpenModal(true);
                    setModalMessage('FORMULARE_AMLZ_ROZCESTNIK_INVALID_LEI');
                })
                .finally(() => {
                    setLoading(false);
                });
        }
    };
    const onSelectChange = () => {
        const values = form.getFieldsValue(['emitentje', 'podobacp']);
        (values.emitentje !== undefined || menuProfile?.typemitenta) &&
        values.podobacp !== undefined &&
        values.podobacp !== EEmitentZadaOpridISIN.LISTINNY
            ? setShowOsobaSelect(true)
            : setShowOsobaSelect(false);
        form.resetFields(['evidencecp']);
    };

    useEffect(() => {
        onSelectChange();
        form.setFieldsValue({
            evidencecp: isRegistration
                ? EEvidenceCp.CDCPDLT
                : identifikacePutData?.evidencecp || rozcestnikInput?.evidencecp
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <LoadingWrapper loading={loading}>
            <FormWrapper outForm={form} onFinish={onFinish}>
                {isRegistration && (
                    <InputComponent
                        label={isRegistration ? 'ISIN_JINA_JURISDIKCE' : 'ISIN'}
                        name="cval"
                        type="text"
                        maxLength={12}
                        rules={isinValidation(true)}
                        // initialValue={data?.isin}
                        capitalize={true}
                        disabled={leiCheck}
                    />
                )}
                {!leiCheck && (
                    <>
                        <SelectComponent
                            name="podobacp"
                            labelParagraph="ISIN_ROZCESTNIK_PRIDELENI_ISIN"
                            infoTooltipText="ISIN_ROZCESTNIK_HELP"
                            isFormItem={true}
                            onChange={() => {
                                onSelectChange();
                                setDruhCP(undefined);
                                identifikacePutData?.druhcp &&
                                    setIdentifikacePutData(pv => {
                                        const newState = {
                                            ...pv
                                        };
                                        delete newState.druhcp;
                                        delete newState.evidencecp;
                                        return newState;
                                    });
                            }}
                            data={emitentZadaOpridISN}
                            defaultValue={
                                isRegistration
                                    ? EEmitentZadaOpridISIN.ZAKNIHOVANY
                                    : identifikacePutData?.podobacp || rozcestnikInput?.podobacp
                            }
                            disabled={isRegistration}
                        />
                        {showOsobaSelect && (
                            <SelectComponent
                                name="evidencecp"
                                labelParagraph="ISIN_ROZCESTNIK_PRIDELENI_OSOBA"
                                isFormItem={true}
                                data={
                                    form.getFieldValue('podobacp') === EEmitentZadaOpridISIN.ZAKNIHOVANY
                                        ? evidenceCpSelectZAKN
                                        : evidenceCpSelect
                                }
                                disabled={isRegistration}
                                defaultValue={isRegistration ? EEvidenceCp.CDCPDLT : undefined}
                                /* onChange={val =>
                                    val === EEvidenceCp.CDCPDLT &&
                                    form.setFieldsValue({
                                        podobacp: EEmitentZadaOpridISIN.ZAKNIHOVANY
                                    }) 
                                } */
                            />
                        )}
                    </>
                )}
                <InputComponent
                    disabled={true}
                    initialValue={aktivniFirma?.ic}
                    label="IDENTIFIKACNI_CISLO"
                    name="idmb"
                    type="text"
                    notRequired={true}
                />
                <SelectComponent
                    disabled={true}
                    placeholder={aktivniFirma?.stat?.toUpperCase()}
                    defaultValue={aktivniFirma?.stat?.toUpperCase()}
                    isFormItem={true}
                    notRequired={true}
                    data={cisStaty}
                    name="stat"
                    labelParagraph={'STAT_SIDLA'}
                />
                {leiCheck && (
                    <InputComponent
                        label="LEI_CELE"
                        name="lei"
                        type="text"
                        rules={leiValidation()}
                        initialValue={rozcestnikData?.lei}
                    />
                )}
                <Modal
                    title={
                        <TranslateText>
                            {modalMessage !== 'ZADOST_O_ISIN_AMLZ' &&
                            modalMessage !== 'FORMULARE_CEKANI_NA_ZPRACOVANI_AMLZ'
                                ? 'NEVALIDNI_LEI'
                                : 'ZADOST_O_AMLZ'}
                        </TranslateText>
                    }
                    open={openModal}
                    onCancel={() => setOpenModal(false)}
                    afterClose={() => {
                        setOpenModal(false);
                        setLoading(false);
                    }}
                    footer={null}
                >
                    <Row>
                        <Paragraph text={modalMessage} />
                    </Row>
                    <Row className="button-row">
                        <ButtonComponent
                            buttontext="ZAVRIT"
                            id="isinModalZpetBtn"
                            type="default"
                            onClick={() => {
                                setOpenModal(false);
                                setLoading(false);
                            }}
                        />

                        {modalMessage === 'ZADOST_O_ISIN_AMLZ' && (
                            <AnchorComponent
                                link={true}
                                to={aktivniFirma ? `/firma/${aktivniFirma?.iducet}${routePathEnum.AMLZ_FORMULAR}` : ''}
                            >
                                <ButtonComponent
                                    id="isinModalAmlzRedirectBtn"
                                    buttontext="PREJIT_NA_AMLZ"
                                    onClick={() => {
                                        setOpenModal(false);
                                        setLoading(false);
                                    }}
                                />
                            </AnchorComponent>
                        )}
                    </Row>
                </Modal>

                <Row className="button-row">
                    {leiCheck && (
                        <Col>
                            <ButtonComponent
                                buttontext="ZPET"
                                onClick={() => setLeiCheck(false)}
                                type="default"
                                id="isinZpetBtn"
                            />
                        </Col>
                    )}
                    <Col>
                        <ButtonComponent
                            buttontext="POKRACOVAT"
                            onClick={() => form.submit()}
                            id="isinPokracovatBtn"
                            disabled={!!errMessage}
                            extramessage={errMessage}
                        />
                    </Col>
                </Row>
            </FormWrapper>
        </LoadingWrapper>
    );
};

export default Rozcestnik;
